import { z } from "zod";

const id = z.string().min(1).max(100).regex(/^[a-zA-Z0-9_-]+$/);
/** Public editorial annotations refer to saved cues; screenplay content stays in Scene/Beat. */
export const zStoryReview = z.object({
  title: z.string().min(1).max(200),
  description: z.string().max(4000),
  previousPerformanceId: id.optional(),
  bookmarks: z.array(z.object({
    id,
    title: z.string().min(1).max(200),
    description: z.string().max(2000),
    sceneId: id,
    cueId: id,
    previousSceneId: id.optional(),
    previousCueId: id.optional(),
  }).strict()).max(100),
}).strict().superRefine((review, context) => {
  if (new Set(review.bookmarks.map(b => b.id)).size !== review.bookmarks.length)
    context.addIssue({ code: "custom", message: "Review bookmark IDs must be unique." });
  if (!review.previousPerformanceId && review.bookmarks.some(b => b.previousSceneId || b.previousCueId))
    context.addIssue({ code: "custom", message: "Comparison cues need a previous performance." });
});
export type StoryReview = z.infer<typeof zStoryReview>;
